import React, { useState, useEffect } from 'react';
import { collection, getDocs, updateDoc, deleteDoc, doc } from 'firebase/firestore';
import { db } from '../firebase'; // Adjust according to your Firebase setup
import NavbarAdmin from '../components/NavbarAdmin';
import './styles/ManageStatDom.css';

const ManageEtat = () => {
  const [etatData, setEtatData] = useState([]);
  const [editId, setEditId] = useState(null);
  const [editData, setEditData] = useState({
    annee: '',
    lien: ''
  });

  useEffect(() => {
    const fetchEtatData = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'etat_finance'));
        const data = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setEtatData(data);
      } catch (error) {
        console.error("Error fetching documents: ", error);
      }
    };

    fetchEtatData();
  }, []);

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditData({ ...editData, [name]: value });
  };

  // Function to convert Google Drive view link to preview link
  const convertToPreviewLink = (link) => {
    if (link.includes('drive.google.com')) {
      return link.replace('/view', '/preview');
    }
    return link; // Return the link unchanged if it's not a Google Drive link
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    const previewLink = convertToPreviewLink(editData.lien); // Convert the link before updating
    try {
      const docRef = doc(db, 'etat_finance', editId);
      await updateDoc(docRef, { ...editData, lien: previewLink });
      alert("Document mis à jour avec succès!");
      setEditId(null);
      setEditData({ annee: '', lien: '' });

      // Refetch data to update the table
      const querySnapshot = await getDocs(collection(db, 'etat_finance'));
      const data = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setEtatData(data);
    } catch (error) {
      console.error("Error updating document: ", error);
    }
  };

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm("Êtes-vous sûr de vouloir supprimer ce document ?");
    if (confirmDelete) {
      try {
        await deleteDoc(doc(db, 'etat_finance', id));
        alert("Document supprimé avec succès!");

        // Refetch data to update the table
        const querySnapshot = await getDocs(collection(db, 'etat_finance'));
        const data = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setEtatData(data);
      } catch (error) {
        console.error("Error deleting document: ", error);
      }
    }
  };

  const currentYear = new Date().getFullYear();
  const years = [];
  for (let i = currentYear - 5; i <= currentYear + 5; i++) {
    years.push(i);
  }

  const headingStyle = {
    fontSize: '2rem', /* Adjust the font size as needed */
    color: '#cc6699', /* Dark grey color for readability */
    fontFamily: 'Chalkboard, Comic Sans MS, cursive, sans-serif',
    margin: '20px 0', /* Space above and below the heading */
    textAlign: 'center', /* Centers the heading text */
    borderBottom: '2px solid #ddd', /* Adds a subtle border below the heading */
    paddingBottom: '10px' /* Adds space between the text and the border */
  };

  const inputStyle = {
    padding: '10px',
    borderRadius: '4px',
    border: '1px solid #ddd',
    width: '100%',
    boxSizing: 'border-box',
  };

  const buttonStyle = {
    padding: '10px 20px',
    backgroundColor: '#6699CC',
    border: 'none',
    borderRadius: '4px',
    color: '#fff',
    fontSize: '1rem',
    cursor: 'pointer',
  };

  const formStyle = {
    marginTop: '20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    maxWidth: '600px',
    margin: '0 auto',
  };

  return (
    <div>
      <NavbarAdmin />
      <div className="manage-statistics">
        <h2 style={headingStyle}>Gérer les États Financiers</h2>
        <table>
          <thead>
            <tr>
              <th>Année</th>
              <th>Lien Drive</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {etatData.map(etat => (
              <tr key={etat.id}>
                <td className="annee">{etat.annee}</td>
                <td>{etat.lien}</td>
                <td>
                  <button
                    className="modifier"
                    onClick={() => {
                      setEditId(etat.id);
                      setEditData({
                        annee: etat.annee,
                        lien: etat.lien
                      });
                    }}
                  >
                    Modifier
                  </button>&nbsp;&nbsp;
                  <button
                    className="supprimer"
                    onClick={() => handleDelete(etat.id)}
                  >
                    Supprimer
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {editId && (
          <form onSubmit={handleEditSubmit} style={formStyle}>
            <h3 style={{ color: '#6699CC' }}>Modifier l'État Financier</h3>
            <label>
              Année:
              <select
                name="annee"
                value={editData.annee}
                onChange={handleEditChange}
                required
                style={inputStyle}
              >
                {years.map(year => (
                  <option key={year} value={year}>{year}</option>
                ))}
              </select>
            </label>
            <label>
              Lien Drive:
              <input
                type="text"
                name="lien"
                value={editData.lien}
                onChange={handleEditChange}
                required
                style={inputStyle}
              />
            </label>
            <button type="submit" style={buttonStyle}>Mettre à jour</button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ManageEtat;
